//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatMoney } from "@/utils";
export default {
  methods: {
    formatMoney,
  },
};
